import styled from "@emotion/styled";
import { Link, useParams } from "react-router";

import { Box, Flex } from "@/components/layout/flexbox";
import { buildSessionUrl } from "@/components/pages_logged_in/roleplays/utils";
import { IconCircle } from "@/components/pieces/IconCircle";
import { RankIcon } from "@/components/pieces/roleplays/RankIcon";
import { RoleplaySessionMenu } from "@/components/pieces/roleplays/RoleplaySessionMenu";
import { LIGHT_STEEL_GRAY, SUBTEXT_COLOR } from "@/css/constants";
import { FullScenario } from "@/types/roleplays";
import { formatDate } from "@/utils/datetime";

interface ScenarioHistoryProps {
  scenario: FullScenario;
  excludeSessionUuid?: string;
}

export function ScenarioHistory({
  scenario,
  excludeSessionUuid,
}: ScenarioHistoryProps) {
  const roleplaySlug = useParams<{
    roleplaySlug?: string;
  }>()?.roleplaySlug;

  const roleplaySessions = scenario.roleplaySessions.filter(
    (roleplaySession) =>
      !(excludeSessionUuid && roleplaySession.uuid === excludeSessionUuid),
  );

  return (
    <HistoryContainer>
      <Flex alignItems="center">
        <IconCircle icon="lightning" mr={2} />
        <Box fontSize={20} fontWeight={600}>
          Previous Sessions
        </Box>
      </Flex>
      {roleplaySessions.length === 0 && (
        <Box
          p={3}
          className="round-corners"
          backgroundColor={LIGHT_STEEL_GRAY}
          color={SUBTEXT_COLOR}
        >
          No sessions... yet!
        </Box>
      )}
      {roleplaySessions.map((roleplaySession) => {
        const timestamp = formatDate(
          roleplaySession.updatedAt,
          "MMM do, yyyy 'at' h:mm a",
        );

        return (
          <SessionContainer
            key={roleplaySession.id}
            className="bas round-corners"
            backgroundColor="#FFF"
            p={3}
          >
            <Flex justifyContent="space-between" alignItems="center">
              <Flex alignItems="center">
                <RankIcon rank={roleplaySession.rank} size={24} />
                <Box fontWeight={600} ml={2} className="color-inherit">
                  <Link
                    to={buildSessionUrl({
                      roleplaySlug,
                      scenarioSlug: scenario.slug,
                      sessionUuid: roleplaySession.uuid,
                    })}
                  >
                    {timestamp}
                  </Link>
                </Box>
              </Flex>
              <RoleplaySessionMenu roleplaySession={roleplaySession} />
            </Flex>
          </SessionContainer>
        );
      })}
    </HistoryContainer>
  );
}

const HistoryContainer = styled(Box)`
  display: grid;
  grid-gap: 16px;
  grid-template-columns: 1fr;
`;

const SessionContainer = styled(Box)`
  .answer-menu {
    margin-top: -20px;
    transform: translateX(-3px);
  }
`;
